export const EXPERIMENT_NAME = window.config.EXPERIMENT_NAME
export const APP_ID = window.config.APP_ID
export const APP_APPLE_LINK = window.config.APP_APPLE_LINK
export const APP_GOOGLE_LINK = window.config.APP_GOOGLE_LINK
export const GOOGLE_CUSTOMER_ID = window.config.GOOGLE_CUSTOMER_ID
export const PIXEL_ID = window.config.PIXEL_ID
export const TIKTOK_PIXEL_ID = window.config.TIKTOK_PIXEL_ID
export const TWITTER_CONF = window.config.TWITTER_CONF
export const TW_PIXEL_ID = TWITTER_CONF?.pixel_id
export const STRIPE_PUBLISHED_KEY = window.config.STRIPE_PUBLISHED_KEY
export const PAY_PAL_CLIENT_ID = window.config.PAY_PAL_CLIENT_ID

export const CANCELATION_POLICY_LINK =
  'https://great-apps.zendesk.com/hc/en-us/articles/28320539101713-Refund-Policy'
export const TERMS_SERVICE_LINK =
  'https://great-apps.zendesk.com/hc/en-us/articles/28321178482577-Terms-of-Service'
export const PRIVACY_POLICY_LINK =
  'https://great-apps.zendesk.com/hc/en-us/articles/28319992746129-Privacy-Policy'
export const PAYMENT_METHODS = window.config.PAYMENT_METHODS
export const PAYMENT_SCREEN_VERSION = window.config.PAYMENT_SCREEN_VERSION
export const EXTRA_DISCOUNT_BANNER = window.config.EXTRA_DISCOUNT_BANNER
export const LTP_PAYMENT_SCREEN_VERSION = window.config.LTP_PAYMENT_SCREEN_VERSION
